import { AciDeliverySessionType } from '../../../../constants/aci';

export const useDeliverySessionTypes = () =>
    Object.values(AciDeliverySessionType);
